// extracted by mini-css-extract-plugin
export default {"btns":"TableItem_btns__NSFyY"};